import React from 'react'

import SignalIntentCalculator from './SignalIntentCalculator'

const AutoLoanCalculatorBlock = () => {
  return <SignalIntentCalculator Guid='e06b98c0-4ced-4030-9e2d-62dacb23220f' />
}

export default React.memo(AutoLoanCalculatorBlock)
